import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import ResizeHook from '../Components/Hooks/ResizeHook';

const Layout = ({ children }) => {

    const widthResize = ResizeHook();

    return (
        <>
            <Header />
            {widthResize > 991 && <Sidebar />}
            <main className="maincontent">
                {children}
            </main>
            <Footer />
        </>
    )
}

export default Layout;